import { lazy } from 'react';

const CreateDemoStudentPlanModalV2 = lazy(
  () => import('./components/CreateDemoStudentPlanModalV2'),
);

export default {
  CREATE_DEMO_STUDENT_PLAN_MODAL: CreateDemoStudentPlanModalV2,
};
